/*
 * Mega menu interactions.
 *
 * Hover and keyboard focus reveal panels via CSS (:hover, :focus-within).
 * This file handles two cases CSS cannot:
 *   - Touch devices: first tap opens the panel, second tap navigates.
 *   - Escape key closes any open panel and returns focus to its trigger.
 *   - Outside-click closes any open panel.
 */
(function () {
  var coarsePointer = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;

  function panelFor(trigger) {
    var item = trigger.closest('.mega-menu__item--has-children');
    return item ? item.querySelector(':scope > .mega-menu__panel') : null;
  }

  function openPanel(panel, trigger) {
    panel.classList.add('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function closePanel(panel) {
    panel.classList.remove('is-open');
    var item = panel.closest('.mega-menu__item--has-children');
    var trigger = item && item.querySelector(':scope > [data-mega-menu-toggle]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function closeAll(except) {
    document.querySelectorAll('.mega-menu__panel.is-open').forEach(function (p) {
      if (p !== except) closePanel(p);
    });
  }

  document.addEventListener('click', function (ev) {
    var trigger = ev.target.closest('[data-mega-menu-toggle]');
    if (trigger && coarsePointer) {
      var panel = panelFor(trigger);
      if (panel && !panel.classList.contains('is-open')) {
        ev.preventDefault();
        closeAll(panel);
        openPanel(panel, trigger);
        return;
      }
    }
    if (!ev.target.closest('.mega-menu__item--has-children')) {
      closeAll();
    }
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape' && ev.key !== 'Esc') return;
    var openOne = document.querySelector('.mega-menu__panel.is-open');
    if (!openOne) return;
    var item = openOne.closest('.mega-menu__item--has-children');
    var trigger = item && item.querySelector(':scope > [data-mega-menu-toggle]');
    closePanel(openOne);
    if (trigger) trigger.focus();
  });
})();
